module.exports = __webpack_public_path__ + "static/media/landing-mobile-1x.bffd3fdd.jpg";